import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'
import {
  StoreDefaultBreadType,
  StoreDefaultDeliveryBreadType,
  StoreDefaultScheduleType,
  StoreDefaultType,
} from 'types/storeDefault'
import {
  fetchStoreDefault,
  fetchStoreDefaultBread,
  fetchStoreDefaultDeliveryBread,
  fetchStoreDefaultSchedules,
} from 'repos/storeDefault'

// 商品テンプレートが2つ以上になる場合は実装を変える必要がある
const useFetchStoreDefault = () => {
  const storeRef = useSelector((state: State) => getStoreRef(state))

  const [storeDefault, setStoreDefault] = useState<StoreDefaultType | undefined>(undefined)
  const [storeDefaultBread, setStoreDefaultBread] = useState<StoreDefaultBreadType | undefined>(undefined)
  const [storeDefaultSchedules, setStoreDefaultSchedules] = useState<StoreDefaultScheduleType[]>([])
  const [storeDefaultDeliveryBread, setStoreDefaultDeliveryBread] = useState<StoreDefaultDeliveryBreadType | undefined>(
    undefined
  )

  useEffect(() => {
    ;(async () => {
      if (!storeRef) return
      const storeDefault = await fetchStoreDefault(storeRef)
      if (!storeDefault) return
      const storeDefaultRef = storeDefault.ref
      const storeDefaultBread = await fetchStoreDefaultBread(storeDefaultRef)
      const storeDefaultSchedules = await fetchStoreDefaultSchedules(storeDefaultRef)
      const storeDefaultDeliveryBread = await fetchStoreDefaultDeliveryBread(storeDefaultRef)
      setStoreDefault(storeDefault)
      setStoreDefaultBread(storeDefaultBread)
      setStoreDefaultSchedules(storeDefaultSchedules)
      setStoreDefaultDeliveryBread(storeDefaultDeliveryBread)
    })()
  }, [storeRef])

  return {
    storeDefault,
    storeDefaultBread,
    storeDefaultSchedules,
    storeDefaultDeliveryBread,
  }
}

export default useFetchStoreDefault
